import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './tab-buttons.scss';

class TabButtons extends PureComponent {
  render() {
    return (
      <ul className="tab-buttons">
        <li>
          <div>График доходности</div>
          <Link
            to="/we/chart/"
            className="btn btn-flex solid-turq btn-graph"
          />
        </li>
        <li>
          <div>Новости</div>
          <Link
            to="/we/news/"
            className="btn btn-flex solid-turq btn-news"
          />
        </li>
        <li>
          <div>Инвестиционный клуб</div>
          <button
            type="button"
            className="btn btn-flex solid-turq btn-invest-club"
            onClick={this.props.onSubscribeClick}
          />
        </li>
      </ul>
    );
  }
}

TabButtons.propTypes = {
  onSubscribeClick: PropTypes.func
};

export default TabButtons;



// WEBPACK FOOTER //
// ./src/components/Layout/Subnavigation/TabButtons.js